import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CertificationDocService } from '../_services';
import * as CertificationDocActions from '../_actions/certificationDoc';

@Injectable({
  providedIn: 'root',
})
export class CertificationDocEffects {
  loadCertificationDocs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificationDocActions.loadCertificationDocs),
      mergeMap(() =>
        this.certificationDocService.getCertificationDocs().pipe(
          map((certificationDocs) =>
            CertificationDocActions.loadCertificationDocsSuccess({ certificationDocs })
          ),
          catchError((error) => of(CertificationDocActions.loadCertificationDocsFailure({ error })))
        )
      )
    )
  );

  addCertificationDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificationDocActions.addCertificationDoc),
      mergeMap(({ certificationDoc }) =>
        this.certificationDocService.saveCertificationDoc(certificationDoc).pipe(
          map((savedCertificationDoc) =>
            CertificationDocActions.addCertificationDocSuccess({
              certificationDoc: savedCertificationDoc,
            })
          ),
          catchError((error) => of(CertificationDocActions.addCertificationDocFailure({ error })))
        )
      )
    )
  );

  updateCertificationDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificationDocActions.updateCertificationDoc),
      mergeMap(({ certificationDoc }) =>
        this.certificationDocService.saveCertificationDoc(certificationDoc).pipe(
          map((updatedCertificationDoc) =>
            CertificationDocActions.updateCertificationDocSuccess({
              certificationDoc: updatedCertificationDoc,
            })
          ),
          catchError((error) =>
            of(CertificationDocActions.updateCertificationDocFailure({ error }))
          )
        )
      )
    )
  );

  deleteCertificationDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificationDocActions.deleteCertificationDoc),
      mergeMap(({ id }) =>
        this.certificationDocService.deleteCertificationDoc(id).pipe(
          map(() => CertificationDocActions.deleteCertificationDocSuccess({ id })),
          catchError((error) =>
            of(CertificationDocActions.deleteCertificationDocFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private certificationDocService: CertificationDocService
  ) {}
}
